<template>
  <Transition name="fade">
    <div v-if="companyOfficers.length && showOfficers && !focus" :class="{ 'p-8': loading }" class="combo-select">
      <DrLoader v-if="loading" />
      <div v-if="!loading && companyOfficers.length">
        <div class="combo-heading">
          {{ companyOfficers.length > 1 ? `Are you one of these people?` : `Are you this person?` }}
        </div>
        <div class="combo-list">
          <div
            v-for="(officer, index) in companyOfficers"
            :key="`${officer.name} ${officer.appointed_on}`"
            class="combo-item"
            :data-cy="`select-officer-${index}`"
            tabindex="0"
            @click="selectOfficer(officer)"
            @keydown.enter.prevent="selectOfficer(officer)"
          >
            <div class="flex items-center">
              <div
                :class="gradientClass(index)"
                class="ml-1 text-2xs text-white rounded-full h-8 w-8 flex items-center justify-center"
              >
                <span>{{ formatName(officer.name).initials }}</span>
              </div>
              <div class="ml-3">
                <div>{{ formatName(officer.name).fullName }}</div>
                <div class="combo-meta">{{ officer.officer_role }}</div>
              </div>
            </div>
            <DrIcon svg="angle-right" width="25" height="25" class="combo-icon" />
          </div>
        </div>
        <div class="combo-link border-t border-grey-200">
          <DrButton class="btn-sm btn-blue btn-outline inline-block text-2xs" @click.prevent="selectOfficer('')">
            {{ companyOfficers.length > 1 ? `I'm not one of these people` : `I'm not this person` }}
          </DrButton>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script>
import axiosCompaniesHouseApi from '@/services/axiosCompaniesHouseApi'
import formatNameMixin from '@/mixins/FormatName'

export default {
  mixins: [formatNameMixin],
  props: {
    businessNumber: {
      type: String,
      required: true,
    },
  },
  data () {
    return {
      companyOfficers: [],
      loading: false,
      focus: false,
    }
  },
  watch: {
    businessNumber: {
      handler () {
        this.searchDirectors()
      },
      immediate: true,
    },
  },
  methods: {
    selectOfficer (officer) {
      this.$emit('change', officer)
    },
    async searchDirectors () {
      try {
        const { data } = await axiosCompaniesHouseApi.get(`company/${this.businessNumber}/officers`)
        this.loading = false
        // Get only active officers
        this.companyOfficers = data.items.filter(officer => !officer.resigned_on)
        this.showOfficers = true
      } catch (e) {}
    },
    gradientClass (index) {
      const gradientClasses = [
        'bg-gradient-primary-orange',
        'bg-gradient-blue-secondary',
        'bg-gradient-yellow-orange',
        'bg-gradient-green-blue',
      ]
      return gradientClasses[index % gradientClasses.length]
    },
  },
}
</script>

<style scoped>
.combo-icon {
  @apply text-blue-500;
}
</style>
